<svelte:options customElement={{
  tag: 'input-text',
  shadow: 'none',
  props: {
    name: { reflect: true, type: 'String' },
    placeholder: { reflect: true, type: 'String' },
    value: { reflect: true, type: 'String' },
    error: { reflect: true, type: 'String' },
    widthClass: { reflect: true, type: 'String', attribute: 'width-class' }
  }
}} />

<script>
  /**
   * textbox：テキストボックス
   * パーツライブラリ準拠の mod-inputText 構造
   */
  export let name = '';
  export let placeholder = 'テキストボックス';
  export let value = '';
  export let error = '';
  export let widthClass = 'width-u-100 width-sp-100';

  let inputId = `input_${name || Math.random().toString(36).slice(2, 8)}`;
</script>

<div class:__error={!!error}>
  <div class="mod-inputText">
    <label for={inputId} title={name}>
      <input
        id={inputId}
        type="text"
        {placeholder}
        class={widthClass}
        bind:value
        on:input
        on:change
      />
    </label>
  </div>
  {#if error}
    <p class="color_red mt10">{error}</p>
  {/if}
</div>
